<template>
  <div id="userPicker">
    <model v-if="newShowModel" class="newUserModel" :buttonType="0" :title="title" :minWidth="'1100px'" v-on:on-cancel="cancelModel()" v-on:on-confirm="confirModel()">
     <div class="m_t_10" >
        <div class="w20 split_2">
          <div :class="isHCP ? 'messagePushTabActive' : ''" @click="switchHCP(1)" class="p_t_b_5 b_t_r_10 border_dede t_c" style="font-size: 14px;">HCP</div>
          <div :class="isHCP ? '' : 'messagePushTabActive'" @click="switchHCP(0)" class="p_t_b_5 b_t_r_10 border_dede t_c" style="font-size: 14px;margin-left: -15px;border-left: none;">员工</div>
        </div>
        <div class="allSearch">  
          <div class="newSearch d_flex" style="margin: 0 0 0 20px;" v-show="isHCP">
            <div style="white-space: normal;">
              <p v-if="needGroup">
                <abbr class="d_i">
                  <allSelect :chooseData="groupList" :needReturn="'id'" :placeholder="'请选择分组'" :matchValue="'name'" :showValue="'{{name}}'" v-model="postData.groupId">
                  </allSelect>
                </abbr>
              </p>
              <p>
                <input @keyup.enter="getList(1)" class="allInput" type="text" placeholder="姓名/微信号" v-model="postData.UserName">
              </p>
              <p>
                <input @keyup.enter="getList(1)" class="allInput" type="text" placeholder="所在地" v-model="postData.city">
              </p>

              <p>
                <input @keyup.enter="getList(1)" class="allInput" type="text" placeholder="医院" v-model="postData.Inst">
              </p>
              <p>
                <abbr class="d_i">
                  <allSelect :chooseData="fildsList" v-on:on-change="fildChange" :needReturn="'id'" :placeholder="'请选择领域'" :matchValue="'name'" :showValue="'{{name}}'" v-model="postData.FieldId">
                  </allSelect>
                </abbr>
              </p>
              <p>
                <!-- <input @keyup.enter="getList" class="allInput" type="text" placeholder="科室" v-model="postData.Dept"> -->
                <newSelect :width="'200px'" class="d_i v_m" :showSearch="true" :multiple="true" :chooseData="filedDeptsList" :needReturn="'deptName'"  v-on:selectValue="getMulDept($event)" :placeholder="'请选择科室'" :matchValue="'deptName'" :showValue="'{{deptName}}'" v-model="postData.Dept" :borderLine="'#e1e1e1'">
                </newSelect>
              </p>
              <p>
                <abbr class="d_i">
                  <allSelect :chooseData="indicationsList" :needReturn="'id'" :placeholder="'请选择适应症'" :matchValue="'name'" :showValue="'{{name}}'" v-model="postData.IndicationId">
                  </allSelect>
                </abbr>
              </p>
              
              <p>
                <abbr class="d_i">
                  <allSelect :chooseData="countyHCPList" :needReturn="'id'" :placeholder="'全部'" :matchValue="'name'" :showValue="'{{name}}'" v-model="countyHCPId">
                  </allSelect>
                </abbr>
              </p>
            </div>
            <div style="width: auto">
              <button style="margin-bottom: 10px" @click="reset()" class="cancelButtonTwo m_r_10 m_l_10">
                <!-- <i class="icon iconfont iconguanbi2"></i> -->
                重置
              </button>
              <button style="margin-bottom: 10px" @click="getList(1)" class="redButton m_l_10">
                <!-- <i class="icon iconfont iconsousuo"></i> -->
                搜索
              </button>
            </div>
          </div>

          <div class="newSearch d_flex" style="margin: 0 0 0 20px;" v-show="!isHCP">
            <div style="width: auto;white-space: normal">
              <p>
                <abbr class="d_i">
                  <allSelect :chooseData="groupList" :needReturn="'id'" :placeholder="'请选择分组'" :matchValue="'name'" :showValue="'{{name}}'" v-model="postDataEmp.GroupId">
                  </allSelect>
                </abbr>
              </p>
              <p><input @keyup.enter="getAll(1)" class="allInput" type="text" placeholder="姓名" v-model="postDataEmp.Name"></p>
              <p><input @keyup.enter="getAll(1)" class="allInput" type="text" placeholder="邮箱" v-model="postDataEmp.Email"></p>
              <!-- <p><input @keyup.enter="getAll(1)" class="allInput" type="text" placeholder="部门" v-model="postDataEmp.Department"></p> -->
              <newSelect :borderLine="'#e1e1e1'" :showSearch="true"  class="d_in v_m" :chooseData="departmentList" :needReturn="'department'" :placeholder="'请选择部门'" :matchValue="'name'" :showValue="'{{name}}'" v-model="postDataEmp.Department">
              </newSelect>

            </div>
            <div style="width: auto">
              <button @click="reset()" class="cancelButtonTwo m_r_10 m_l_10">
                重置
              </button>
              <button class="redButton m_l_10" @click="getAll(1)">搜索</button>
            </div>
          </div>

        </div>

        <div>

          
        </div>

        <div v-show="isHCP" class="d_flex" style="display: inline-block;vertical-align: top;width:calc(100% - 250px);">
          <div class="messagePushTabRadius allSearch w100 d_i" style="margin: 0;">
            <div class="allTablePlace d_i" style="vertical-align: top;width: calc(100% - 30px)">
              <div style="height: 250px;overflow: auto;">
                <table cellspacing="0" class="allTable">
                  <thead style="background-color: rgba(240,240,240,0.3);">
                  <tr class="table_th_bottom">
                    <th width="5%">
                      <input @change="chooseAllData" v-model="selectAll" type="checkbox" class="allCheckbox" id="ALLchecked" name="checked"/>
                      <label for="ALLchecked"></label>
                    </th>
                   <th>姓名/微信号</th>
                  <th>所在地</th>
                  <th>科室</th>
                  <th>医院</th>
                  <th>领域</th>
                  <th>适应症</th>
                  </tr>
                  </thead>
                  <tbody>
                  <tr :key="index" v-for="(item, index) in userList">
                    <td width="5%">
                      <input @change="chooseUserInfo(item)" v-model="item.checked" type="checkbox" class="allCheckbox" :id="'userChecked' + index" name="checked"/>
                      <label :for="'userChecked' + index"></label>
                    </td>
                    <td width="20%" class="NoWrap" style="max-width: 100px" :title="item.name">{{item.docName ? item.docName.replace(/ /g, '&nbsp;') : ''}}</td>
                    <td width="15%" class="NoWrap" style="max-width: 100px" :title="item.city">{{item.city}}</td>
                    <td width="15%" class="NoWrap" style="max-width: 100px" :title="item.department">{{item.department}}</td>
                    <td width="15%" class="NoWrap" style="max-width: 100px" :title="item.instName">{{item.instName}}</td>
                    <td width="15%" class="NoWrap" style="max-width: 100px" :title="item.fields">{{item.fields}}</td>
                    <td width="15%" class="NoWrap" style="max-width: 100px" :title="item.indications">{{item.indications}}</td>
                  </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
          <div> 
            <button class="redButton m_l_40" @click="allSelectUser('HCP')">全选</button>
          </div>
        </div>
        <div v-show="!isHCP" style="display: inline-block;vertical-align: top;width:calc(100% - 250px);">
          <div class="messagePushTabRadius allSearch w100 d_i p_r" style="margin: 0;">

            <div class="allTablePlace d_i" style="vertical-align: top;width: calc(100% - 30px)">
              <div style="height: 250px;overflow: auto;">
                <table cellspacing="0" class="allTable" style="width: 100%">
                  <thead style="background-color: rgba(240,240,240,0.3);">
                  <tr class="table_th_bottom">
                    <th width="5%">
                      <input @change="chooseAllData" v-model="selectAll" type="checkbox" class="allCheckbox" id="ALLchecked" name="checked"/>
                      <label for="ALLchecked"></label>
                    </th>
                    <th>姓名</th>
                    <th>邮箱</th>
                    <th>部门</th>
                  </tr>
                  </thead>
                  <tbody>
                  <tr :key="index" v-for="(item, index) in userList">
                    <td width="5%">
                      <input @change="chooseUserInfo(item)" v-model="item.checked" type="checkbox" class="allCheckbox" :id="'userChecked' + index" name="checked"/>
                      <label :for="'userChecked' + index"></label>
                    </td>
                    <td width="20%">{{item.name}}</td>
                    <td width="30%">{{item.email}}</td>
                   <td :title="item.department" class="NoWrap">{{item.department}}</td>
                  </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
          <div> 
            <button class="redButton m_l_40" @click="allSelectUser('employee')">全选</button>
          </div>
        </div>
        <div style="display: inline-block;vertical-align: top;width:240px;margin-top: -26px;padding:20px 0; box-sizing: boeder-box">
          <div style="padding-left: 20px;color: #666" class="f_w">已选人员：{{chooseUserList.length}}</div>
          <div style="height: 270px;overflow: auto;margin: 10px;padding:10px;border: 1px solid #eee;border-radius: 10px;">
            <div :title="item.name" class="allSelectedMember" :key="index" v-for="(item, index) in chooseUserList">{{item.type || (item.email ? '员工' : 'HCP')}} | {{ item.name || item.docName || item.nickName}} <b @click="removeSelect(item.openId)">X</b> </div>
          </div>
        </div>
        <div>
          <newPage v-if="totalPage !== 0 && isHCP" :typeInId="'HCPPage'" :needPageSize="true" :pageSize="postData.PageSize" :totalCount="totalCount" v-on:on-getList="getList($event)" v-on:on-changeSize="changeNewSize" :totalPage="totalPage" :page="page" :explain="0"></newPage>
          <newPage1 v-if="totalPage1 !== 0 && !isHCP" :typeInId="'yuanGongPage'" :needPageSize="true" :pageSize="postDataEmp.pageSize" :totalCount="totalCount1" v-on:on-getList="getAll($event)" v-on:on-changeSize="changeNewSize1" :totalPage="totalPage1" :page="page" :explain="0"></newPage1>
        </div>
      </div>
    </model>
  </div>
</template>

<script>
import newPage from './page'
import newPage1 from './newPage1'
import _ from 'lodash'
export default {
  name: 'page',
  model: {
    prop: 'newShowModel',
    event: 'newShowModel'
  },
  props: [
    'title',
    'userListType',
    'newShowModel',
    'pickerModel',
    'needGroup',
    'groupId',
    'appId',
    'pushInfo',
    'pushType'
  ],
  data () {
    return {
			originUserList: [],
      userList: [],
			chooseUserList: [],
			totalPage: 1,
			totalPage1: 1,
      totalCount: 0,
      totalCount1: 0,
      page: 1,
      chooseUserIdList: [],
      chooseIdList: [],
      selectAll: false,
      isHCP: true,
			postData: {
        groupId: '0',
        value: '',
        Field: '',
        FieldId: '',
        IndicationId: '',
        
        name: '',
        Email: '',
        org_Acronym: '',
        keywords: '',
        ChineseName: '',
        Department: '',
        JobTitle: '',
        PageIndex: 1,
        PageSize: this.$commonJs.commonPageSize,
        IndicationName: '' // 适应症
      },
      postDataEmp: {
        keywords: '',
        Name: '',
        Email: '',
        pageIndex: 1,
        GroupId: '',
        pageSize: 10
      },
      groupList: [{id: '0', name: '请选择分组'}],
      fildsList: [{id: '', name: '请选择领域'}],
			departList: [],
      fieldsList: [],
      indicationsList: [],
      countyHCPList:[{id:'0',name:'全部'},{id:'1',name:'县域医生'},{id:'2',name:'非县域医生'}],
      countyHCPId:'0',
      departmentList: [],
      filedDeptsList: []
    }
  },
  created () { // vue 页面的生命周期 当我一进来页面之后 我先执行
    this.getGroupList()
    this.getFildsList()
    this.GetFiledDepts('0')
  },
  mounted () { // vue 页面的生命周期 当我进来之后 且加载完资源了之后再执行
		this.getDepart()
		// 获取领域
		this.getFieldsList()
		// 获取适应症
		this.getIndicationsList()
    this.getEmployeeDepartment()
  },
  methods: {
    reset(){
      if (this.isHCP){
        this.countyHCPId='0'
        this.postData = {
          groupId: '0',
          value: '',
          Field: '',
          FieldId: '',
          IndicationId: '',
          name: '',
          Email: '',
          org_Acronym: '',
          keywords: '',
          ChineseName: '',
          Department: '',
          JobTitle: '',
          PageIndex: this.postData.PageIndex,
          PageSize: this.postData.PageSize,
          IndicationName: '' // 适应症
        }
        this.getList(1)
      } else {
        this.postDataEmp = {
          keywords: '',
          Name: '',
          Email: '',
          pageIndex: this.postDataEmp.pageIndex,
          GroupId: '',
          pageSize: this.postDataEmp.pageSize
        }
        this.getAll(1)
      }
    },
    getMulDept(e){
      this.postData.Dept = e
    },
    fildChange(e){
      console.log(e)
      this.GetFiledDepts(e.id || '0')
      this.postData.Dept = ''
    },
    // /api/Dict/GetFiledDepts/depts/{fieldId}
    GetFiledDepts(fieldId){
      if (fieldId){
        this.$axiox.get(`/api/Dict/GetFiledDepts/depts/${fieldId}`).then( p => {
          this.filedDeptsList = p
        } )
      } else {
        this.filedDeptsList = []
      }

    },
    allSelectUser(type){
      let url = '/api/Group/GetAllHcps/GetAllHcpsByConditions'
      let data = {}
      if (type === 'HCP'){
        if(this.countyHCPId==='0'){
          url = '/api/Group/GetAllHcps/GetAllHcpsByConditions'
        }else if(this.countyHCPId==='1'){
          url = '/api/Group/GetAllHcpsByConditionsArea'
        }else if(this.countyHCPId==='2'){
          url = '/api/Group/GetAllHcpsByConditionsNonArea'
        }      
        data = JSON.parse(JSON.stringify(this.postData))
        delete data.PageIndex
        delete data.PageSize
      } else {
        url = '/api/Group/GetAllEmployees/GetAllEmployeesByConditions'
        data = JSON.parse(JSON.stringify(this.postDataEmp))
        delete data.pageIndex
        delete data.pageSize
      }

      this.$axiox.get(this.$commonJs.returnQuery(url, data)).then( p => {
        if(p && p.length){
          for (let i = 0; i < p.length; i++){
            if (this.chooseUserIdList.indexOf(p[i].openId) < 0) {
              this.chooseUserList.push(p[i])
              this.chooseUserIdList.push(p[i].openId)
              this.chooseIdList.push(p[i].openId)
            }
          }
          let openIds = p.map( m => m.openId )
          this.userList.forEach( m => {
            if (openIds.indexOf(m.openId) > -1){
              m.checked = true
            }
          } )
          let checkedLen = this.userList.filter( m => m.checked ).length
          if (checkedLen === this.postData.PageSize){
            this.selectAll = true
          }
        }

      } )
    },
    changeNewSize (e) {
      this.postData.PageSize = e
      this.getList(1)
    },
    changeNewSize1 (e) {
      this.postDataEmp.pageSize = e
      this.getAll(1)
    },
    getEmployeeDepartment () {
      this.$axiox.get('/api/Group/GetAllEmployeeDepartment').then( p => {
        this.departmentList = [{
          name: '全部',
          department: ''
        }].concat(p || [])
      })
    },
		// HCP
    changeField () {
      this.postData.IndicationId = ''
      if (this.postData.FieldId) {
        let FieldId = (this.postData.FieldId.split(',')).map(item => Number(item))
        this.getIndicationsList(FieldId)
      } else {
        this.getIndicationsList()
      }
    },
    removeSelect (id) {
      this.chooseUserList.splice(this.chooseUserIdList.indexOf(id), 1)
      this.chooseUserIdList.splice(this.chooseUserIdList.indexOf(id), 1)
      this.chooseIdList.splice(this.chooseUserIdList.indexOf(id), 1)
      let num = 0
      for (let i = 0; i < this.userList.length; i++) {
        if (this.userList[i].openId === id) {
          this.$set(this.userList[i], 'checked', false)
        }
        if (this.userList[i].checked) {
          num++
        }
      }
      if (num === this.userList.length) {
        this.selectAll = true
      } else {
        this.selectAll = false
      }
    },
		// 选择用户
    chooseUserInfo (item) {
      if (this.isHCP) {
        if (item.checked) {
          if (this.chooseUserIdList.indexOf(item.openId) >= 0) {
          } else {
            this.chooseUserList.push(item)
            this.chooseUserIdList.push(item.openId)
            this.chooseIdList.push(item.openId)
          }
        } else {
          if (this.chooseUserIdList.indexOf(item.openId) >= 0) {
            this.chooseUserList.splice(this.chooseUserIdList.indexOf(item.openId), 1)
            this.chooseUserIdList.splice(this.chooseUserIdList.indexOf(item.openId), 1)
            this.chooseIdList.splice(this.chooseUserIdList.indexOf(item.openId), 1)
          } else {
          }
        }
      } else {
        if (item.checked) {
          if (this.chooseUserIdList.indexOf(item.openId) >= 0) {
          } else {
            this.chooseUserList.push(item)
            this.chooseUserIdList.push(item.openId)
            this.chooseIdList.push(item.openId)
          }
        } else {
          if (this.chooseUserIdList.indexOf(item.openId) >= 0) {
            this.chooseUserList.splice(this.chooseUserIdList.indexOf(item.openId), 1)
            this.chooseUserIdList.splice(this.chooseUserIdList.indexOf(item.openId), 1)
            this.chooseIdList.splice(this.chooseUserIdList.indexOf(item.openId), 1)
          } else {
          }
        }
      }
      if (this.chooseUserList.length === this.userList.length) {
        this.selectAll = true
      } else {
        this.selectAll = false
      }
      console.log('select-----++', this.chooseUserList, this.userList)
    },
		// 选取所有人
    chooseAllData () {
      for (let i = 0; i < this.userList.length; i++) {
        this.$set(this.userList[i], 'checked', this.selectAll)
        if (this.isHCP) {
          if (this.selectAll) {
            if (this.chooseUserIdList.indexOf(this.userList[i].openId) < 0) {
              this.chooseUserList.push(this.userList[i])
              this.chooseUserIdList.push(this.userList[i].openId)
              this.chooseIdList.push(this.userList[i].openId)
            }
          } else {
            if (this.chooseUserIdList.indexOf(this.userList[i].openId) >= 0) {
              this.chooseUserList.splice(this.chooseUserIdList.indexOf(this.userList[i].openId), 1)
              this.chooseUserIdList.splice(this.chooseUserIdList.indexOf(this.userList[i].openId), 1)
              this.chooseIdList.splice(this.chooseUserIdList.indexOf(this.userList[i].openId), 1)
              i--
            }
          }
        } else {
          if (this.selectAll) {
            if (this.chooseUserIdList.indexOf(this.userList[i].openId) < 0) {
              this.chooseUserList.push(this.userList[i])
              this.chooseUserIdList.push(this.userList[i].openId)
              this.chooseIdList.push(this.userList[i].openId)
            }
          } else {
            if (this.chooseUserIdList.indexOf(this.userList[i].openId) >= 0) {
              this.chooseUserList.splice(this.chooseUserIdList.indexOf(this.userList[i].openId), 1)
              this.chooseUserIdList.splice(this.chooseUserIdList.indexOf(this.userList[i].openId), 1)
              this.chooseIdList.splice(this.chooseUserIdList.indexOf(this.userList[i].openId), 1)
              i--
            }
          }
        }
      }
      console.log('chooseUserList--', this.chooseUserList)
    },
		switchHCP (value) {
      this.isHCP = value === 1
      if (value === 1) {
        this.getList(1)
      } else {
        this.getAll(1)
      }
    },
		 // 获取HCP列表
    getList (pageIndex) {
      this.postData.PageIndex = pageIndex || 1
      let data = JSON.parse(JSON.stringify(this.postData))
      data.endSubTime = data.endSubTime ? encodeURIComponent(data.endSubTime + ' 23:59:59') : ''
      data.endRegTime = data.endRegTime ? encodeURIComponent(data.endRegTime + ' 23:59:59') : ''
      if (data.IsKOL === '') {
        delete data['IsKOL']
      }
      if (data.isRz === '') {
        delete data['isRz']
      }
      if (data.isFollewd === '') {
        delete data['isFollewd']
      }
      console.log(data, 'data')
      console.log(this.postData, 'this.postData')
      let tempUrl=''
      if(this.countyHCPId==='0'){
        tempUrl = data.groupId && data.groupId != '0' ? '/api/Group/GetWechatUserByGroup' : '/api/Group/GetAllGroupUsers'
      }else if(this.countyHCPId==='1'){
        tempUrl = data.groupId && data.groupId != '0' ? '/api/Group/GetWechatUserByGroupArea' : '/api/Group/GetAllGroupUsersArea'
      }else if(this.countyHCPId==='2'){
        tempUrl = data.groupId && data.groupId != '0' ? '/api/Group/GetWechatUserByGroupNonArea' : '/api/Group/GetAllGroupUsersNonArea'
      }
      let url = this.$commonJs.returnQuery(tempUrl, data)
      this.$axiox.getList(url, data).then(msg => {
        console.log(msg, 'msg----')
        this.userList = msg.data
        this.userList.forEach(p => {
          if (this.chooseUserList.filter(x => x.openId === p.openId).length > 0) {
            this.$set(p, 'checked', true)
          }
        })
        this.originUserList = JSON.parse(JSON.stringify(msg.data))
        this.page = pageIndex
        this.totalPage = Math.ceil(msg.total / this.postData.PageSize)
        console.log(this.totalPage)
        this.totalCount = msg.total
        let num = 0
        for (let i = 0; i < this.userList.length; i++) {
          if (this.chooseUserIdList.indexOf(this.userList[i].openId) >= 0) {
            this.$set(this.userList[i], 'checked', true)
          }
          if (this.userList[i].checked) {
            num++
          }
        }
        if (num === this.userList.length) {
          this.selectAll = true
        } else {
          this.selectAll = false
        }
        console.log(this.userTotalPage)
      })
    },
    getGroupList () {
      let url = this.$commonJs.returnQuery('/api/Group/GetByName', {PageIndex: 1, PageSize: 9999})
      this.$axiox.getList(url).then(msg => {
        this.groupList = this.groupList.concat(msg.data)
      })
    },
    getFildsList () {
      let url = this.$commonJs.returnQuery('/api/Dict/GetFields', {})
      this.$axiox.getList(url).then(msg => {
        // for (let i = 0; i < msg.data.length; i++) {
        //   msg.data[i].postId = msg.data[i].name
        // }
        this.fildsList = this.fildsList.concat(msg.data)
      })
    },
		// 获取领域
    getFieldsList () {
      this.$axiox.get(`/api/Dict/GetFields`).then(res => {
        console.log(res, 'getFieldsList')
        let data = [{
          id: '',
          name: '全部'
        }]
        this.fieldsList = data.concat(res)
      })
    },
    getIndicationsList (ids = []) {
      let params = ids
      this.$axiox.post(`/api/Dict/GetIndications`, params).then(res => {
        this.indicationsList = [
          {id: '', name: '请选择适应症'},
          ...res
        ]
      })
    },
		getDepart (callback) {
      this.$axiox.get('/api/Dict/GetHosDepts').then(p => {
        for (let i = 0; i < p.length; i++) {
          p[i].nameId = p[i].description
        }
        this.departList = this.departList.concat(p)
        if (callback) {
          callback()
        }
      })
    },
		// 员工
    getAll (PageNum) {
      this.postDataEmp.pageIndex = PageNum
      let data = JSON.parse(JSON.stringify(this.postDataEmp))
      if (!data.GroupId || data.GroupId === '0'){
        delete data.GroupId
      }
      let url = this.$commonJs.returnQuery('/api/Group/GetAllGroupEmployees', data)
      this.$axiox.getList(url, data).then(msg => {
        this.page = PageNum
        // console.log(msg)
        this.userList = msg.data
        this.totalPage1 = Math.ceil(msg.total / this.postDataEmp.pageSize)
        this.totalCount1 = msg.total
        let num = 0
        for (let i = 0; i < this.userList.length; i++) {
          if (this.chooseUserIdList.indexOf(this.userList[i].openId) >= 0) {
            this.$set(this.userList[i], 'checked', true)
          }
          if (this.userList[i].checked) {
            num++
          }
        }
        if (num === this.userList.length) {
          this.selectAll = true
        } else {
          this.selectAll = false
        }
      })
    },
		cancelModel () {
      this.$emit('newShowModel', false)
    },
    confirModel () {
      this.$emit('newShowModel', false)
      let dataList = {
        chooseUserIdList: this.chooseUserIdList,
        chooseUserList: this.chooseUserList,
        chooseIdList: this.chooseIdList
      }
      this.$emit('choosedConfirm', dataList)
			console.log(dataList)
    }
  },
  components: {
    'newPage': newPage,
    'newPage1': newPage1
  },
  watch: {
    newShowModel (value) {
      console.log(value)
      if (value) {
				if (this.isHCP) {
					this.getList(1)
          this.getEmployeeDepartment()
				} else {
					this.getAll(1)
				}
      }
    },
    "postData.FieldId" (newData) {

    },
    pushType (value) {
      this.chooseUserList = []
      this.chooseUserIdList = []
      this.chooseIdList = []
      if (!value) {
        this.chooseUserList = _.cloneDeep(this.pushInfo)
        this.chooseUserList.forEach(itm => {
          if (itm.openID) {
            itm.openId = itm.openID
          }
          if (this.chooseUserIdList.indexOf(itm.openId) < 0 && itm.openId) {
            this.chooseUserIdList.push(itm.openId)
          }
          if (this.chooseIdList.indexOf(itm.openId) < 0 && itm.openId) {
            this.chooseIdList.push(itm.openId)
          }
        }
        )
      }
    },
    pushInfo (value) {
      this.chooseUserList = []
      this.chooseUserIdList = []
      this.chooseIdList = []
      if (!this.pushType) {
        this.chooseUserList = _.cloneDeep(value)
        this.chooseUserList.forEach(itm => {
          if (itm.openID) {
            itm.openId = itm.openID
          }
          if (this.chooseUserIdList.indexOf(itm.openId) < 0 && itm.openId) {
            this.chooseUserIdList.push(itm.openId)
          }
          if (this.chooseIdList.indexOf(itm.openId) < 0 && itm.openId) {
            this.chooseIdList.push(itm.openId)
          }
        }
        )
      }
    }
  }
}
</script>

<style scoped>
  .allSelectedMember{
    padding: 10px 20px;
    border-radius: 10px;
    background: #FEF5F0;
    margin: 10px 0;
    overflow: hidden;
    position: relative;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
  .allSelectedMember b{
    position: absolute;
    right: 10px;
    cursor: pointer;
  }
	.newUserModel >>> .allModelOverFlow{
		max-height: 700px!important;
	}
</style>



// WEBPACK FOOTER //
// src/components/myComponents/newUserPicker.vue